(function (window, $) {

  var eventsManager = {

    init: function () {
      const _this = this;

      $('body').on('click', '.em-search-btn', function () {
        $('.em-search-submit').click();
      });

      $('body').on('click', '.em-search-submit', function () {
        _this.resetUrl();
      });

      $('body').on('click', '.em-reset-filters', function (e) {
        e.preventDefault();
        _this.resetAll();
      });

      // Datepicker fix
      $(document).on('_page_loaded', function () {
        let load_ui_css;
        if ($('.em-date-single, .em-date-range, #em-date-start').length > 0) {
          load_ui_css = true;
          em_setup_datepicker('body');
        }
        if (load_ui_css) em_load_jquery_css();
      });
    },

    resetAll: function () {
      $('.em-search-advanced select').val(0);
      $('.em-events-search-text, .em-date-input-loc').val('');
      $('.em-search-submit').trigger('click');
    },

    resetUrl: function () {
      const url = new URL(window.location.href);
      const params = url.searchParams;
      let keys = ['category', 'em_language', 'em_mode'];
      let changeUrl = false;

      keys.forEach(function (key) {
        if (params.get(key)) {
          params.delete(key);
          changeUrl = true;
        }
      });

      if (changeUrl) {
        history.replaceState(null, '', url.href);
      }
    }

  };

  $(document).ready(function () {
    eventsManager.init();
  });

})(window, jQuery);
